import { Component, Input, Output, EventEmitter, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-sl-button',
  standalone: true,
  imports: [NgIf],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <sl-button
      [variant]="variant"
      [size]="size"
      [disabled]="disabled"
      [loading]="loading"
      [outline]="outline"
      [pill]="pill"
      [circle]="circle"
      [caret]="caret"
      [type]="type"
      (click)="onClick($event)">

      <sl-icon *ngIf="prefixIcon" [name]="prefixIcon" slot="prefix"></sl-icon>
      <ng-content></ng-content>
      <sl-icon *ngIf="suffixIcon" [name]="suffixIcon" slot="suffix"></sl-icon>
    </sl-button>
  `,
  styleUrls: ['./sl-button.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SlButtonComponent {
  @Input() variant: 'default' | 'primary' | 'success' | 'neutral' | 'warning' | 'danger' | 'text' = 'default';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() outline: boolean = false;
  @Input() pill: boolean = false;
  @Input() circle: boolean = false;
  @Input() caret: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() prefixIcon?: string;
  @Input() suffixIcon?: string;

  @Output() buttonClick = new EventEmitter<Event>();

  onClick(event: Event): void {
    if (!this.disabled && !this.loading) {
      this.buttonClick.emit(event);
    }
  }
}
